(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/main-page.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/main-page.js');

'use strict';

const _svs$playerLoginReact = svs.playerLoginReact.sharedComponents,
  FooterText = _svs$playerLoginReact.FooterText,
  HeaderText = _svs$playerLoginReact.HeaderText,
  LoginIframe = _svs$playerLoginReact.LoginIframe,
  LoginPaper = _svs$playerLoginReact.LoginPaper,
  ScamWarning = _svs$playerLoginReact.ScamWarning,
  SvsLogo = _svs$playerLoginReact.SvsLogo;
const ProductCylinderWrapper = svs.tb_ui_react.cylinder_wrapper.ProductCylinderWrapper;
const allowedGames = svs.playerLoginReact.constants.allowedGames;
const useStatusBarColor = svs.components.tb_ui_react.useStatusBarColor.useStatusBarColor;
const isLogin = false;
const defultSelectedGames = [allowedGames.EUROJACKPOT, allowedGames.TRISS, allowedGames.LOTTO];

const MainPage = _ref => {
  let children = _ref.children;
  const isStandardMobile = ReactRedux.useSelector(state => state.playerloginreact.isStandardMobile);
  const branding = ReactRedux.useSelector(state => state.playerloginreact.theme.branding);
  const fontColor = ReactRedux.useSelector(state => state.playerloginreact.theme.fontColor);
  const brandingArray = branding ? Array(3).fill(branding) : defultSelectedGames;
  useStatusBarColor('player-login-react-view');
  return React.createElement(React.Fragment, null, React.createElement(ProductCylinderWrapper, {
    isDefault: !branding,
    products: brandingArray
  }), React.createElement("div", {
    className: "u-position-relative"
  }, React.createElement("div", {
    className: "".concat(fontColor, " align-center f-body line-height-150 u-flex u-flex-column login-react-main-page padding-1 login-react-max-width-500")
  }, React.createElement(HeaderText, {
    isBankId: true,
    isLogin: isLogin
  }), isStandardMobile && React.createElement("div", {
    className: "u-flex-grow-1"
  }, React.createElement(SvsLogo, null)), React.createElement("div", {
    className: "padding-bottom-1".concat(!isStandardMobile ? ' u-flex-grow-1' : '')
  }, svs.accountservices.check_iam.isIamIFrameEnabled ? React.createElement(LoginIframe, null) : React.createElement(LoginPaper, null, children), React.createElement(FooterText, {
    isBankId: true,
    isLogin: isLogin
  }), React.createElement(ScamWarning, null)), !isStandardMobile && React.createElement("div", {
    className: "margin-bottom-2"
  }, React.createElement(SvsLogo, null)))));
};
svs.playerLoginReact.sharedComponents.MainPage = MainPage;

 })(window);